"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorCode = void 0;
var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode[ValidationErrorCode["InvalidBirthDate"] = 0] = "InvalidBirthDate";
    ValidationErrorCode[ValidationErrorCode["InvalidIndividualDigits"] = 1] = "InvalidIndividualDigits";
    ValidationErrorCode[ValidationErrorCode["InvalidSsnFormat"] = 2] = "InvalidSsnFormat";
    ValidationErrorCode[ValidationErrorCode["InvalidControlDigits"] = 3] = "InvalidControlDigits"; // Control digits do not match birth date and individual digits.
})(ValidationErrorCode = exports.ValidationErrorCode || (exports.ValidationErrorCode = {}));
//# sourceMappingURL=ValidationErrorCode.js.map